import { useEffect, useRef, useState } from "react";
import { Button, Chips, Flex, Paper, Text } from "@pillar-ui/core";
import colors from "../styles/colors";

export default function SpinningWheel({ data, onFinish }) {
  const [spinning, setSpinning] = useState(false);
  const [rotation, setRotation] = useState(0);
  const [result, setResult] = useState(null);
  const [previousIndex, setPreviousIndex] = useState(0);
  const audioRef = useRef(null);

  const spin = () => {
    if (spinning) return;
    enableSound();

    const sliceAngle = 360 / data.length;
    const randomIndex = Math.floor(Math.random() * data.length);
    let targetRotation = 360 * 5 + randomIndex * sliceAngle; // 5 full spins + landing
    setRotation((oldValue) => oldValue + targetRotation);
    setSpinning(true);
    setResult(null);

    setTimeout(() => {
      setSpinning(false);
      let newPreviousIndex = previousIndex + (data?.length - randomIndex);
      if (newPreviousIndex >= data?.length) {
        newPreviousIndex -= data?.length;
      }
      onFinish?.(data[newPreviousIndex]);
      setResult(data[newPreviousIndex]);
      setPreviousIndex(newPreviousIndex);
    }, 5000); // match transition duration
  };

  const enableSound = () => {
    if (audioRef.current) {
      audioRef.current.muted = false;
      audioRef.current.play();
    }
  };

  useEffect(() => {
    // Play when component renders
    if (audioRef.current) {
      audioRef.current.play().catch((err) => {
        console.warn("Autoplay blocked by browser:", err);
      });
    }
  }, []);

  return (
    <>
      <Flex direction="col" items="center" gap="4">
        <Paper
          style={{
            width: 300,
            height: 300,
            overflow: "hidden",
            position: "relative",
            borderRadius: "50%",
            border: "4px solid gray",
          }}
        >
          {/* Wheel */}
          <Paper
            style={{
              transform: `rotate(${rotation}deg)`,
              transitionDuration: spinning ? "5s" : "0s",
              transitionTimingFunction: "ease-in-out",
              position: "absolute",
              inset: 0,
              borderRadius: "50%",
            }}
          >
            {data.map((item, i) => {
              const sliceAngle = 360 / data.length;
              return (
                <Paper
                  key={i}
                  style={{
                    position: "absolute",
                    width: "50%",
                    height: "50%",
                    background: item.backgroundColor,
                    transformOrigin: "100% 100%",
                    transform: `rotate(${(i + 1 / 2) * sliceAngle}deg) skewY(${
                      90 - sliceAngle
                    }deg)`,
                    //   clipPath: "polygon(0 0, 100% 0, 100% 100%)",
                  }}
                />
              );
            })}
          </Paper>

          {/* Pointer */}
          <Paper
            style={{
              position: "absolute",
              top: -5,
              left: "50%",
              transform: "translateX(-50%)",
              width: 0,
              height: 0,
              borderLeft: "12px solid transparent",
              borderRight: "12px solid transparent",
              borderTop: "30px solid white",
            }}
          />
        </Paper>
        <Flex direction="col" justify="center" style={{ height: 75 }}>
          {!spinning &&
            (result?.label ? (
              <Chips
                corner="4"
                style={{ backgroundColor: result?.backgroundColor, padding: 8 }}
              >
                <Text
                  size="9"
                  style={{
                    fontWeight: 700,
                    color: colors.white,
                  }}
                >
                  {result?.label}
                </Text>
              </Chips>
            ) : (
              <Text size="9" color="p">
                {"Mời thử vận may!"}
              </Text>
            ))}
        </Flex>
        <Button onClick={spin} disabled={spinning}>
          {"Quay 🎯"}
        </Button>
      </Flex>
      <audio ref={audioRef} src="/musics/spinning-wheel-music.aac" loop />
    </>
  );
}
